// fetchWithAuth.ts (oder fetchClient.ts)
import { sessionManager } from '../core/SessionManager';

/**
 * Wrapper für fetch mit automatischer Authentifizierung und Token-Refresh
 * Bei 401 wird automatisch versucht, den Token zu erneuern
 */
export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  // Prüfe Offline-Status
  if (!navigator.onLine) {
    console.log(`🌐 Offline erkannt, blockiere REST API Request zu ${url}`);
    throw new Error('Offline: Keine Internetverbindung verfügbar');
  }

  const token = sessionManager.getToken();

  const finalHeaders = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token || ''}`,
  };

  let response = await fetch(url, {
    ...options,
    headers: finalHeaders,
  });

  // Bei 401 Unauthorized: Versuche Token-Refresh
  if (response.status === 401) {
    console.warn('Token abgelaufen oder ungültig - versuche Token-Erneuerung...');
    
    try {
      // Versuche, einen neuen Token über Cookie-basierte Session zu holen
      await sessionManager.bootstrapFromServer();
      
      // Hole den neuen Token
      const newToken = sessionManager.getToken();
      
      if (newToken) {
        console.log('Token erfolgreich erneuert - wiederhole ursprüngliche Anfrage');
        
        // Wiederhole die ursprüngliche Anfrage mit dem neuen Token
        const retryHeaders = {
          ...(options.headers || {}),
          Authorization: `Bearer ${newToken}`,
        };
        
        response = await fetch(url, {
          ...options,
          headers: retryHeaders,
        });
        
        // Wenn es immer noch 401 ist, dann logout
        if (response.status === 401) {
          console.error('Token-Erneuerung fehlgeschlagen - Benutzer wird ausgeloggt');
          await sessionManager.logout();
        }
      } else {
        // Kein neuer Token erhalten - Logout
        console.error('Keine Token-Erneuerung möglich - Benutzer wird ausgeloggt');
        await sessionManager.logout();
      }
    } catch (error) {
      console.error('Fehler bei Token-Erneuerung:', error);
      await sessionManager.logout();
    }
  }
  
  return response;
}
